import {
  FiBox, FiCheckCircle, FiClipboard, FiDroplet, FiFileText, FiGrid, FiLayers, FiMaximize,
  FiPackage, FiPenTool, FiSettings, FiShoppingBag, FiShoppingCart, FiTag, FiTruck, FiWind,
} from "react-icons/fi";
import { getProductBySlug } from "../../data/products";
import { getPackagingOptions } from "../../data/packaging";
import { moqBySku } from "../../data/moq";

export const LAUNDRY_COLLECTION_PATH = "/products?category=sheets";
export const PACKAGING_PATH = "/products/laundry-detergent-sheets#product-laundry-detergent-sheets-detail-packaging";
export const MOQ_PATH = "/products/laundry-detergent-sheets#product-laundry-detergent-sheets-detail-moq";

export const processSteps = [
  { icon: FiLayers, title: "Choose Your Product", copy: "Start with laundry detergent sheets and a formula direction." },
  { icon: FiDroplet, title: "Select Formula & Fragrance", copy: "Compare formulas and scents or discuss custom development." },
  { icon: FiPackage, title: "Customize Packaging", copy: "Choose your format, sheet count and branding direction." },
  { icon: FiClipboard, title: "Review Samples", copy: "Confirm performance, fragrance and packaging before production." },
  { icon: FiCheckCircle, title: "Approve & Produce", copy: "Finalize artwork and specifications, then move into manufacturing." },
  { icon: FiTruck, title: "Ship", copy: "Coordinate freight, customs and delivery to your destination." },
];
export const customizationOptions = [
  { icon: FiDroplet, title: "Formula", copy: "Existing formulas or custom development." },
  { icon: FiWind, title: "Fragrance", copy: "Available scents or a custom direction." },
  { icon: FiMaximize, title: "Sheet Size", copy: "Dimensions and perforation options." },
  { icon: FiLayers, title: "Sheet Count", copy: "A pack size that fits your market." },
  { icon: FiPackage, title: "Packaging", copy: "Boxes, envelopes and pouches." },
  { icon: FiPenTool, title: "Artwork & Branding", copy: "Your identity, prepared for print." },
];
export const packagingOptions = getPackagingOptions("KL-LDS-RG");
export const businessFacts = [
  { value: `${moqBySku["KL-LDS-RG"].quantity}*`, label: "Starting retail MOQ" },
  { value: "Custom", label: "Formula & fragrance" },
  { value: "Private Label", label: "Packaging & branding" },
  { value: "Global", label: "Shipping coordination" },
];
export const audiences = [
  { icon: FiShoppingCart, title: "E-commerce Brands" },
  { icon: FiShoppingBag, title: "Retail Brands" },
  { icon: FiBox, title: "Wholesalers" },
  { icon: FiTruck, title: "Distributors" },
  { icon: FiTag, title: "Refill Shops" },
];
export const bulkBenefits = [
  { icon: FiLayers, title: "Bulk Loose Sheets", copy: "Available in wholesale case formats." },
  { icon: FiGrid, title: "Flexible Retail Setup", copy: "Pack locally or sell through refill displays." },
  { icon: FiTag, title: "Branded Presentation", copy: "Use jars, labels or your own packaging." },
  { icon: FiTruck, title: "Shipping Support", copy: "Coordinate availability and delivery." },
];
export const manufacturingSupport = [
  { icon: FiDroplet, title: "Product Development", copy: "Support from product selection through approval." },
  { icon: FiFileText, title: "Packaging Coordination", copy: "Artwork, dielines and packaging preparation." },
  { icon: FiSettings, title: "Production Support", copy: "Manufacturing and quality control coordination." },
  { icon: FiTruck, title: "Logistics", copy: "Freight, customs and delivery planning." },
];
export const broaderProducts = [
  { slug: "laundry-detergent-tablets", title: "Tablets", to: "/products?category=tablets" },
  { slug: "laundry-pods", title: "Pods", to: "/products?category=pods" },
  { slug: "floor-cleaning-sheets", title: "Cleaning Sheets", to: "/products?category=sheets" },
  { slug: "laundry-detergent-powder", title: "Powders", to: "/products?category=powders" },
  { slug: "fragrance-booster-beads", title: "Fragrance Beads", to: "/products?category=fragrance-booster-beads" },
  { slug: "stain-removal-spray", title: "Stain Removal", to: "/products?category=stain-removal" },
].map(({ slug, title, to }) => ({ product: getProductBySlug(slug), title, to }));
